var _excluded = ["format", "formatType"],
  _excluded2 = ["format", "formatType"],
  _excluded3 = ["orient"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isArray, isBoolean, isNumber, isString } from 'vega-util';
import { isAggregateOp, isArgmaxDef, isArgminDef, isCountingAggregateOp } from './aggregate';
import { autoMaxBins, binToString, isBinned, isBinning } from './bin';
import { ANGLE, COLOR, COLUMN, DESCRIPTION, DETAIL, FACET, FILL, FILLOPACITY, getSizeChannel, HREF, isScaleChannel, isSecondaryRangeChannel, isXorY, KEY, LATITUDE, LATITUDE2, LONGITUDE, LONGITUDE2, OPACITY, ORDER, RADIUS, RADIUS2, ROW, SHAPE, SIZE, STROKE, STROKEDASH, STROKEOPACITY, STROKEWIDTH, TEXT, THETA, THETA2, TIME, TOOLTIP, URL, X, X2, XOFFSET, Y, Y2, YOFFSET } from './channel';
import { getMarkConfig, getMarkPropOrConfig } from './compile/common';
import { isCustomFormatType } from './compile/format';
import { dateTimeToExpr, isDateTime } from './datetime';
import { isExprRef } from './expr';
import * as log from './log';
import { isRectBasedMark } from './mark';
import { hasDiscreteDomain, isContinuousToDiscrete, SCALE_CATEGORY_INDEX } from './scale';
import { isSortByChannel } from './sort';
import { isFacetFieldDef } from './spec/facet';
import { getTimeUnitParts, isBinnedTimeUnit, isLocalSingleTimeUnit, normalizeTimeUnit, timeUnitToString } from './timeunit';
import { getFullName, QUANTITATIVE } from './type';
import { flatAccessWithDatum, getFirstDefined, hasProperty, internalField, omit, removePathFromField, replacePathInField, stringify, titleCase } from './util';
import { isSignalRef } from './vega.schema';
export function isConditionalParameter(c) {
  return hasProperty(c, 'param');
}
export function isRepeatRef(field) {
  return !isString(field) && hasProperty(field, 'repeat');
}
export function toFieldDefBase(fieldDef) {
  var field = fieldDef.field,
    timeUnit = fieldDef.timeUnit,
    bin = fieldDef.bin,
    aggregate = fieldDef.aggregate;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, timeUnit ? {
    timeUnit: timeUnit
  } : {}), bin ? {
    bin: bin
  } : {}), aggregate ? {
    aggregate: aggregate
  } : {}), {}, {
    field: field
  });
}
export function isSortableFieldDef(fieldDef) {
  return hasProperty(fieldDef, 'sort');
}
export function getBandPosition(_ref) {
  var fieldDef = _ref.fieldDef,
    fieldDef2 = _ref.fieldDef2,
    mark = _ref.markDef,
    config = _ref.config;
  if (isFieldOrDatumDef(fieldDef) && fieldDef.bandPosition !== undefined) {
    return fieldDef.bandPosition;
  }
  if (isFieldDef(fieldDef)) {
    var timeUnit = fieldDef.timeUnit,
      bin = fieldDef.bin;
    if (timeUnit && !fieldDef2) {
      return getMarkConfig('timeUnitBandPosition', mark, config);
    } else if (isBinning(bin)) {
      return 0.5;
    }
  }
  return undefined;
}
export function getBandSize(_ref2) {
  var channel = _ref2.channel,
    fieldDef = _ref2.fieldDef,
    fieldDef2 = _ref2.fieldDef2,
    mark = _ref2.markDef,
    config = _ref2.config,
    scaleType = _ref2.scaleType,
    useVlSizeChannel = _ref2.useVlSizeChannel;
  var sizeChannel = getSizeChannel(channel);
  var size = getMarkPropOrConfig(useVlSizeChannel ? 'size' : sizeChannel, mark, config, {
    vgChannel: sizeChannel
  });
  if (size !== undefined) {
    return size;
  }
  if (isFieldDef(fieldDef)) {
    var timeUnit = fieldDef.timeUnit,
      bin = fieldDef.bin;
    if (timeUnit && !fieldDef2) {
      return {
        band: getMarkConfig('timeUnitBandSize', mark, config)
      };
    } else if (isBinning(bin) && !hasDiscreteDomain(scaleType)) {
      return {
        band: 1
      };
    }
  }
  if (isRectBasedMark(mark.type)) {
    var _config$mark$type3;
    if (scaleType) {
      if (hasDiscreteDomain(scaleType)) {
        var _config$mark$type;
        return ((_config$mark$type = config[mark.type]) === null || _config$mark$type === void 0 ? void 0 : _config$mark$type.discreteBandSize) || {
          band: 1
        };
      } else {
        var _config$mark$type2;
        return (_config$mark$type2 = config[mark.type]) === null || _config$mark$type2 === void 0 ? void 0 : _config$mark$type2.continuousBandSize;
      }
    }
    return (_config$mark$type3 = config[mark.type]) === null || _config$mark$type3 === void 0 ? void 0 : _config$mark$type3.discreteBandSize;
  }
  return undefined;
}
export function hasBandEnd(fieldDef, fieldDef2, markDef, config) {
  if (isBinning(fieldDef.bin) || fieldDef.timeUnit && isTypedFieldDef(fieldDef) && fieldDef.type === 'temporal') {
    // Need to check bandPosition because non-rect marks (e.g., point) with timeUnit
    // doesn't have to use bandEnd if there is no bandPosition.
    return getBandPosition({
      fieldDef: fieldDef,
      fieldDef2: fieldDef2,
      markDef: markDef,
      config: config
    }) !== undefined;
  }
  return false;
}
export function isOrderOnlyDef(orderDef) {
  return hasProperty(orderDef, 'sort') && !hasProperty(orderDef, 'field');
}
export function isConditionalDef(channelDef) {
  return hasProperty(channelDef, 'condition');
}
/**
 * Return if a channelDef is a ConditionalValueDef with ConditionFieldDef
 */
export function hasConditionalFieldDef(channelDef) {
  var condition = channelDef === null || channelDef === void 0 ? void 0 : channelDef['condition'];
  return !!condition && !isArray(condition) && isFieldDef(condition);
}
export function hasConditionalFieldOrDatumDef(channelDef) {
  var condition = channelDef === null || channelDef === void 0 ? void 0 : channelDef['condition'];
  return !!condition && !isArray(condition) && isFieldOrDatumDef(condition);
}
export function hasConditionalValueDef(channelDef) {
  var condition = channelDef === null || channelDef === void 0 ? void 0 : channelDef['condition'];
  return !!condition && (isArray(condition) || isValueDef(condition));
}
export function isFieldDef(channelDef) {
  return hasProperty(channelDef, 'field') || (channelDef === null || channelDef === void 0 ? void 0 : channelDef.aggregate) === 'count';
}
export function channelDefType(channelDef) {
  return channelDef === null || channelDef === void 0 ? void 0 : channelDef['type'];
}
export function isDatumDef(channelDef) {
  return hasProperty(channelDef, 'datum');
}
export function isContinuousFieldOrDatumDef(cd) {
  // TODO: make datum support DateTime object
  return isTypedFieldDef(cd) && !isDiscrete(cd) || isNumericDataDef(cd);
}
export function isUnbinnedQuantitativeFieldOrDatumDef(cd) {
  // TODO: make datum support DateTime object
  return isTypedFieldDef(cd) && cd.type === 'quantitative' && !cd.bin || isNumericDataDef(cd);
}
export function isNumericDataDef(cd) {
  return isDatumDef(cd) && isNumber(cd.datum);
}
export function isFieldOrDatumDef(channelDef) {
  return isFieldDef(channelDef) || isDatumDef(channelDef);
}
export function isTypedFieldDef(channelDef) {
  return channelDef && (hasProperty(channelDef, 'field') || channelDef['aggregate'] === 'count') && hasProperty(channelDef, 'type');
}
export function isValueDef(channelDef) {
  return hasProperty(channelDef, 'value');
}
export function isScaleFieldDef(channelDef) {
  return hasProperty(channelDef, 'scale') || hasProperty(channelDef, 'sort');
}
export function isPositionFieldOrDatumDef(channelDef) {
  return hasProperty(channelDef, 'axis') || hasProperty(channelDef, 'stack') || hasProperty(channelDef, 'impute');
}
export function isMarkPropFieldOrDatumDef(channelDef) {
  return hasProperty(channelDef, 'legend');
}
export function isStringFieldOrDatumDef(channelDef) {
  return hasProperty(channelDef, 'format') || hasProperty(channelDef, 'formatType');
}
export function toStringFieldDef(fieldDef) {
  // omit properties that don't exist in string field defs
  return omit(fieldDef, ['legend', 'axis', 'header', 'scale']);
}
function isOpFieldDef(fieldDef) {
  return hasProperty(fieldDef, 'op');
}
/**
 * Get a Vega field reference from a Vega-Lite field def.
 */
export function vgField(fieldDef) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var field = fieldDef.field;
  var prefix = opt.prefix;
  var suffix = opt.suffix;
  var argAccessor = ''; // for accessing argmin/argmax field at the end without getting escaped
  if (isCount(fieldDef)) {
    field = internalField('count');
  } else {
    var fn;
    if (!opt.nofn) {
      if (isOpFieldDef(fieldDef)) {
        fn = fieldDef.op;
      } else {
        var bin = fieldDef.bin,
          aggregate = fieldDef.aggregate,
          timeUnit = fieldDef.timeUnit;
        if (isBinning(bin)) {
          var _opt$binSuffix, _opt$suffix;
          fn = binToString(bin);
          suffix = ((_opt$binSuffix = opt.binSuffix) !== null && _opt$binSuffix !== void 0 ? _opt$binSuffix : '') + ((_opt$suffix = opt.suffix) !== null && _opt$suffix !== void 0 ? _opt$suffix : '');
        } else if (aggregate) {
          if (isArgmaxDef(aggregate)) {
            argAccessor = "[\"".concat(field, "\"]");
            field = "argmax_".concat(aggregate.argmax);
          } else if (isArgminDef(aggregate)) {
            argAccessor = "[\"".concat(field, "\"]");
            field = "argmin_".concat(aggregate.argmin);
          } else {
            fn = String(aggregate);
          }
        } else if (timeUnit && !isBinnedTimeUnit(timeUnit)) {
          var _opt$suffix2;
          fn = timeUnitToString(timeUnit);
          suffix = (!['range', 'mid'].includes(opt.binSuffix) && opt.binSuffix || '') + ((_opt$suffix2 = opt.suffix) !== null && _opt$suffix2 !== void 0 ? _opt$suffix2 : '');
        }
      }
    }
    if (fn) {
      field = field ? "".concat(fn, "_").concat(field) : fn;
    }
  }
  if (suffix) {
    field = "".concat(field, "_").concat(suffix);
  }
  if (prefix) {
    field = "".concat(prefix, "_").concat(field);
  }
  if (opt.forAs) {
    return removePathFromField(field);
  } else if (opt.expr) {
    // Expression to access flattened field. No need to escape dots.
    return flatAccessWithDatum(field, opt.expr) + argAccessor;
  } else {
    // We flattened all fields so paths should have become dot.
    return replacePathInField(field) + argAccessor;
  }
}
export function isDiscrete(def) {
  switch (def.type) {
    case 'nominal':
    case 'ordinal':
    case 'geojson':
      return true;
    case 'quantitative':
      return isFieldDef(def) && !!def.bin;
    case 'temporal':
      return false;
  }
  throw new Error(log.message.invalidFieldType(def.type));
}
export function isDiscretizing(def) {
  var _def$scale;
  return isScaleFieldDef(def) && isContinuousToDiscrete((_def$scale = def.scale) === null || _def$scale === void 0 ? void 0 : _def$scale.type);
}
export function isCount(fieldDef) {
  return fieldDef.aggregate === 'count';
}
export function verbalTitleFormatter(fieldDef, config) {
  var field = fieldDef.field,
    bin = fieldDef.bin,
    timeUnit = fieldDef.timeUnit,
    aggregate = fieldDef.aggregate;
  if (aggregate === 'count') {
    return config.countTitle;
  } else if (isBinning(bin)) {
    return "".concat(field, " (binned)");
  } else if (timeUnit && !isBinnedTimeUnit(timeUnit)) {
    var _normalizeTimeUnit;
    var unit = (_normalizeTimeUnit = normalizeTimeUnit(timeUnit)) === null || _normalizeTimeUnit === void 0 ? void 0 : _normalizeTimeUnit.unit;
    if (unit) {
      return "".concat(field, " (").concat(getTimeUnitParts(unit).join('-'), ")");
    }
  } else if (aggregate) {
    if (isArgmaxDef(aggregate)) {
      return "".concat(field, " for max ").concat(aggregate.argmax);
    } else if (isArgminDef(aggregate)) {
      return "".concat(field, " for min ").concat(aggregate.argmin);
    } else {
      return "".concat(titleCase(aggregate), " of ").concat(field);
    }
  }
  return field;
}
export function functionalTitleFormatter(fieldDef) {
  var aggregate = fieldDef.aggregate,
    bin = fieldDef.bin,
    timeUnit = fieldDef.timeUnit,
    field = fieldDef.field;
  if (isArgmaxDef(aggregate)) {
    return "".concat(field, " for argmax(").concat(aggregate.argmax, ")");
  } else if (isArgminDef(aggregate)) {
    return "".concat(field, " for argmin(").concat(aggregate.argmin, ")");
  }
  var timeUnitParams = timeUnit && !isBinnedTimeUnit(timeUnit) ? normalizeTimeUnit(timeUnit) : undefined;
  var fn = aggregate || (timeUnitParams === null || timeUnitParams === void 0 ? void 0 : timeUnitParams.unit) || (timeUnitParams === null || timeUnitParams === void 0 ? void 0 : timeUnitParams.maxbins) && 'timeunit' || isBinning(bin) && 'bin';
  return fn ? "".concat(fn.toUpperCase(), "(").concat(field, ")") : field;
}
export var defaultTitleFormatter = function defaultTitleFormatter(fieldDef, config) {
  switch (config.fieldTitle) {
    case 'plain':
      return fieldDef.field;
    case 'functional':
      return functionalTitleFormatter(fieldDef);
    default:
      return verbalTitleFormatter(fieldDef, config);
  }
};
var titleFormatter = defaultTitleFormatter;
export function setTitleFormatter(formatter) {
  titleFormatter = formatter;
}
export function resetTitleFormatter() {
  setTitleFormatter(defaultTitleFormatter);
}
export function title(fieldOrDatumDef, config, _ref3) {
  var _getGuide;
  var allowDisabling = _ref3.allowDisabling,
    _ref3$includeDefault = _ref3.includeDefault,
    includeDefault = _ref3$includeDefault === void 0 ? true : _ref3$includeDefault;
  var guideTitle = (_getGuide = getGuide(fieldOrDatumDef)) === null || _getGuide === void 0 ? void 0 : _getGuide.title;
  if (!isFieldDef(fieldOrDatumDef)) {
    return guideTitle !== null && guideTitle !== void 0 ? guideTitle : fieldOrDatumDef.title;
  }
  var fieldDef = fieldOrDatumDef;
  var def = includeDefault ? defaultTitle(fieldDef, config) : undefined;
  if (allowDisabling) {
    return getFirstDefined(guideTitle, fieldDef.title, def);
  } else {
    var _ref4;
    return (_ref4 = guideTitle !== null && guideTitle !== void 0 ? guideTitle : fieldDef.title) !== null && _ref4 !== void 0 ? _ref4 : def;
  }
}
export function getGuide(fieldDef) {
  if (isPositionFieldOrDatumDef(fieldDef) && fieldDef.axis) {
    return fieldDef.axis;
  } else if (isMarkPropFieldOrDatumDef(fieldDef) && fieldDef.legend) {
    return fieldDef.legend;
  } else if (isFacetFieldDef(fieldDef) && fieldDef.header) {
    return fieldDef.header;
  }
  return undefined;
}
export function defaultTitle(fieldDef, config) {
  return titleFormatter(fieldDef, config);
}
export function getFormatMixins(fieldDef) {
  if (isStringFieldOrDatumDef(fieldDef)) {
    var format = fieldDef.format,
      formatType = fieldDef.formatType;
    return {
      format: format,
      formatType: formatType
    };
  } else {
    var _getGuide2;
    var guide = (_getGuide2 = getGuide(fieldDef)) !== null && _getGuide2 !== void 0 ? _getGuide2 : {};
    var _format = guide.format,
      _formatType = guide.formatType;
    return {
      format: _format,
      formatType: _formatType
    };
  }
}
export function defaultType(fieldDef, channel) {
  var _fieldDef$scale;
  switch (channel) {
    case 'latitude':
    case 'longitude':
      return 'quantitative';
    case 'row':
    case 'column':
    case 'facet':
    case 'shape':
    case 'strokeDash':
      return 'nominal';
    case 'order':
      return 'ordinal';
  }
  if (isSortableFieldDef(fieldDef) && isArray(fieldDef.sort)) {
    return 'ordinal';
  }
  var aggregate = fieldDef.aggregate,
    bin = fieldDef.bin,
    timeUnit = fieldDef.timeUnit;
  if (timeUnit) {
    return 'temporal';
  }
  if (bin || aggregate && !isArgmaxDef(aggregate) && !isArgminDef(aggregate)) {
    return 'quantitative';
  }
  if (isScaleFieldDef(fieldDef) && (_fieldDef$scale = fieldDef.scale) !== null && _fieldDef$scale !== void 0 && _fieldDef$scale.type) {
    switch (SCALE_CATEGORY_INDEX[fieldDef.scale.type]) {
      case 'numeric':
      case 'discretizing':
        return 'quantitative';
      case 'time':
        return 'temporal';
    }
  }
  return 'nominal';
}
/**
 * Returns the fieldDef -- either from the outer channelDef or from the condition of channelDef.
 * @param channelDef
 */
export function getFieldDef(channelDef) {
  if (isFieldDef(channelDef)) {
    return channelDef;
  } else if (hasConditionalFieldDef(channelDef)) {
    return channelDef.condition;
  }
  return undefined;
}
export function getFieldOrDatumDef(channelDef) {
  if (isFieldOrDatumDef(channelDef)) {
    return channelDef;
  } else if (hasConditionalFieldOrDatumDef(channelDef)) {
    return channelDef.condition;
  }
  return undefined;
}
/**
 * Convert type to full, lowercase type, or augment the fieldDef with a default type if missing.
 */
export function initChannelDef(channelDef, channel, config) {
  var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (isString(channelDef) || isNumber(channelDef) || isBoolean(channelDef)) {
    var primitiveType = isString(channelDef) ? 'string' : isNumber(channelDef) ? 'number' : 'boolean';
    log.warn(log.message.primitiveChannelDef(channel, primitiveType, channelDef));
    return {
      value: channelDef
    };
  }
  // If a fieldDef contains a field, we need type.
  if (isFieldOrDatumDef(channelDef)) {
    return initFieldOrDatumDef(channelDef, channel, config, opt);
  } else if (hasConditionalFieldOrDatumDef(channelDef)) {
    return _objectSpread(_objectSpread({}, channelDef), {}, {
      // Need to cast as normalizeFieldDef normally return FieldDef, but here we know that it is definitely Condition<FieldDef>
      condition: initFieldOrDatumDef(channelDef.condition, channel, config, opt)
    });
  }
  return channelDef;
}
export function initFieldOrDatumDef(fd, channel, config, opt) {
  if (isStringFieldOrDatumDef(fd)) {
    var format = fd.format,
      formatType = fd.formatType,
      rest = _objectWithoutProperties(fd, _excluded);
    if (isCustomFormatType(formatType) && !config.customFormatTypes) {
      log.warn(log.message.customFormatTypeNotAllowed(channel));
      return initFieldOrDatumDef(rest, channel, config, opt);
    }
  } else {
    var guideType = isPositionFieldOrDatumDef(fd) ? 'axis' : isMarkPropFieldOrDatumDef(fd) ? 'legend' : isFacetFieldDef(fd) ? 'header' : null;
    if (guideType && fd[guideType]) {
      var _fd$guideType = fd[guideType],
        _format2 = _fd$guideType.format,
        _formatType2 = _fd$guideType.formatType,
        newGuide = _objectWithoutProperties(_fd$guideType, _excluded2);
      if (isCustomFormatType(_formatType2) && !config.customFormatTypes) {
        log.warn(log.message.customFormatTypeNotAllowed(channel));
        return initFieldOrDatumDef(_objectSpread(_objectSpread({}, fd), {}, _defineProperty({}, guideType, newGuide)), channel, config, opt);
      }
    }
  }
  if (isFieldDef(fd)) {
    return initFieldDef(fd, channel, opt);
  }
  return initDatumDef(fd);
}
function initDatumDef(datumDef) {
  var type = datumDef['type'];
  if (type) {
    return datumDef;
  }
  var datum = datumDef.datum;
  type = isNumber(datum) ? 'quantitative' : isString(datum) ? 'nominal' : isDateTime(datum) ? 'temporal' : undefined;
  return _objectSpread(_objectSpread({}, datumDef), {}, {
    type: type
  });
}
export function initFieldDef(fd, channel) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref5$compositeMark = _ref5.compositeMark,
    compositeMark = _ref5$compositeMark === void 0 ? false : _ref5$compositeMark;
  var aggregate = fd.aggregate,
    timeUnit = fd.timeUnit,
    bin = fd.bin,
    field = fd.field;
  var fieldDef = _objectSpread({}, fd);
  // Drop invalid aggregate
  if (!compositeMark && aggregate && !isAggregateOp(aggregate) && !isArgmaxDef(aggregate) && !isArgminDef(aggregate)) {
    log.warn(log.message.invalidAggregate(aggregate));
    delete fieldDef.aggregate;
  }
  // Normalize Time Unit
  if (timeUnit) {
    fieldDef.timeUnit = normalizeTimeUnit(timeUnit);
  }
  if (field) {
    fieldDef.field = "".concat(field);
  }
  // Normalize bin
  if (isBinning(bin)) {
    fieldDef.bin = normalizeBin(bin, channel);
  }
  if (isBinned(bin) && !isXorY(channel)) {
    log.warn(log.message.channelShouldNotBeUsedForBinned(channel));
  }
  // Normalize Type
  if (isTypedFieldDef(fieldDef)) {
    var type = fieldDef.type;
    var fullType = getFullName(type);
    if (type !== fullType) {
      // convert short type to full type
      fieldDef.type = fullType;
    }
    if (type !== 'quantitative') {
      if (isCountingAggregateOp(aggregate)) {
        log.warn(log.message.invalidFieldTypeForCountAggregate(type, aggregate));
        fieldDef.type = 'quantitative';
      }
    }
  } else if (!isSecondaryRangeChannel(channel)) {
    // If type is empty / invalid, then augment with default type
    var newType = defaultType(fieldDef, channel);
    fieldDef['type'] = newType;
  }
  if (isTypedFieldDef(fieldDef)) {
    var _ref6 = channelCompatibility(fieldDef, channel) || {},
      compatible = _ref6.compatible,
      warning = _ref6.warning;
    if (compatible === false) {
      log.warn(warning);
    }
  }
  if (isSortableFieldDef(fieldDef) && isString(fieldDef.sort)) {
    var sort = fieldDef.sort;
    if (isSortByChannel(sort)) {
      return _objectSpread(_objectSpread({}, fieldDef), {}, {
        sort: {
          encoding: sort
        }
      });
    }
    var sub = sort.substring(1);
    if (sort.charAt(0) === '-' && isSortByChannel(sub)) {
      return _objectSpread(_objectSpread({}, fieldDef), {}, {
        sort: {
          encoding: sub,
          order: 'descending'
        }
      });
    }
  }
  if (isFacetFieldDef(fieldDef)) {
    var header = fieldDef.header;
    if (header) {
      var orient = header.orient,
        rest = _objectWithoutProperties(header, _excluded3);
      if (orient) {
        return _objectSpread(_objectSpread({}, fieldDef), {}, {
          header: _objectSpread(_objectSpread({}, rest), {}, {
            labelOrient: header.labelOrient || orient,
            titleOrient: header.titleOrient || orient
          })
        });
      }
    }
  }
  return fieldDef;
}
export function normalizeBin(bin, channel) {
  if (isBoolean(bin)) {
    return {
      maxbins: autoMaxBins(channel)
    };
  } else if (bin === 'binned') {
    return {
      binned: true
    };
  } else if (!bin.maxbins && !bin.step) {
    return _objectSpread(_objectSpread({}, bin), {}, {
      maxbins: autoMaxBins(channel)
    });
  } else {
    return bin;
  }
}
var COMPATIBLE = {
  compatible: true
};
export function channelCompatibility(fieldDef, channel) {
  var type = fieldDef.type;
  if (type === 'geojson' && channel !== 'shape') {
    return {
      compatible: false,
      warning: "Channel ".concat(channel, " should not be used with a geojson data.")
    };
  }
  switch (channel) {
    case ROW:
    case COLUMN:
    case FACET:
      if (!isDiscrete(fieldDef)) {
        return {
          compatible: false,
          warning: log.message.channelShouldBeDiscrete(channel)
        };
      }
      return COMPATIBLE;
    case X:
    case Y:
    case XOFFSET:
    case YOFFSET:
    case COLOR:
    case FILL:
    case STROKE:
    case TEXT:
    case DETAIL:
    case KEY:
    case TOOLTIP:
    case HREF:
    case URL:
    case ANGLE:
    case THETA:
    case RADIUS:
    case DESCRIPTION:
      return COMPATIBLE;
    case LONGITUDE:
    case LONGITUDE2:
    case LATITUDE:
    case LATITUDE2:
      if (type !== QUANTITATIVE) {
        return {
          compatible: false,
          warning: "Channel ".concat(channel, " should be used with a quantitative field only, not ").concat(fieldDef.type, " field.")
        };
      }
      return COMPATIBLE;
    case OPACITY:
    case FILLOPACITY:
    case STROKEOPACITY:
    case STROKEWIDTH:
    case SIZE:
    case THETA2:
    case RADIUS2:
    case X2:
    case Y2:
    case TIME:
      if (type === 'nominal' && !fieldDef['sort']) {
        return {
          compatible: false,
          warning: "Channel ".concat(channel, " should not be used with an unsorted discrete field.")
        };
      }
      return COMPATIBLE;
    case SHAPE:
    case STROKEDASH:
      if (!isDiscrete(fieldDef) && !isDiscretizing(fieldDef)) {
        return {
          compatible: false,
          warning: log.message.channelShouldBeDiscreteOrDiscretizing(channel)
        };
      }
      return COMPATIBLE;
    case ORDER:
      if (fieldDef.type === 'nominal' && !('sort' in fieldDef)) {
        return {
          compatible: false,
          warning: "Channel order is inappropriate for nominal field, which has no inherent order."
        };
      }
      return COMPATIBLE;
  }
}
/**
 * Check if the field def uses a time format or does not use any format but is temporal
 * (this does not cover field defs that are temporal but use a number format).
 */
export function isFieldOrDatumDefForTimeFormat(fieldOrDatumDef) {
  var _getFormatMixins = getFormatMixins(fieldOrDatumDef),
    formatType = _getFormatMixins.formatType;
  return formatType === 'time' || !formatType && isTemporalFieldDef(fieldOrDatumDef);
}
/**
 * Check if field def has type `temporal`. If you want to also cover field defs that use a time format, use `isFieldOrDatumDefForTimeFormat`.
 */
export function isTemporalFieldDef(def) {
  return def && (def['type'] === 'temporal' || isFieldDef(def) && !!def.timeUnit);
}
/**
 * Getting a value associated with a fielddef.
 * Convert the value to Vega expression if applicable (for datetime object, or string if the field def is temporal or has timeUnit)
 */
export function valueExpr(v, _ref7) {
  var _normalizeTimeUnit2;
  var timeUnit = _ref7.timeUnit,
    type = _ref7.type,
    wrapTime = _ref7.wrapTime,
    undefinedIfExprNotRequired = _ref7.undefinedIfExprNotRequired;
  var unit = timeUnit && ((_normalizeTimeUnit2 = normalizeTimeUnit(timeUnit)) === null || _normalizeTimeUnit2 === void 0 ? void 0 : _normalizeTimeUnit2.unit);
  var isTime = unit || type === 'temporal';
  var expr;
  if (isExprRef(v)) {
    expr = v.expr;
  } else if (isSignalRef(v)) {
    expr = v.signal;
  } else if (isDateTime(v)) {
    isTime = true;
    expr = dateTimeToExpr(v);
  } else if (isString(v) || isNumber(v)) {
    if (isTime) {
      expr = "datetime(".concat(stringify(v), ")");
      if (isLocalSingleTimeUnit(unit)) {
        // for single timeUnit, we will use dateTimeToExpr to convert number/string to match the timeUnit
        if (isNumber(v) && v < 10000 || isString(v) && isNaN(Date.parse(v))) {
          expr = dateTimeToExpr(_defineProperty({}, unit, v));
        }
      }
    }
  }
  if (expr) {
    return wrapTime && isTime ? "time(".concat(expr, ")") : expr;
  }
  // number or boolean or normal string
  return undefinedIfExprNotRequired ? undefined : stringify(v);
}
/**
 * Standardize value array -- convert each value to Vega expression if applicable
 */
export function valueArray(fieldOrDatumDef, values) {
  var type = fieldOrDatumDef.type;
  return values.map(function (v) {
    var timeUnit = isFieldDef(fieldOrDatumDef) && !isBinnedTimeUnit(fieldOrDatumDef.timeUnit) ? fieldOrDatumDef.timeUnit : undefined;
    var expr = valueExpr(v, {
      timeUnit: timeUnit,
      type: type,
      undefinedIfExprNotRequired: true
    });
    // return signal for the expression if we need an expression
    if (expr !== undefined) {
      return {
        signal: expr
      };
    }
    // otherwise just return the original value
    return v;
  });
}
/**
 * Checks whether a fieldDef for a particular channel requires a computed bin range.
 */
export function binRequiresRange(fieldDef, channel) {
  if (!isBinning(fieldDef.bin)) {
    console.warn('Only call this method for binned field defs.');
    return false;
  }
  // We need the range only when the user explicitly forces a binned field to be use discrete scale. In this case, bin range is used in axis and legend labels.
  // We could check whether the axis or legend exists (not disabled) but that seems overkill.
  return isScaleChannel(channel) && ['ordinal', 'nominal'].includes(fieldDef.type);
}